// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__WM5A0"};